import { render, staticRenderFns } from "./JsonNestedBlock.vue?vue&type=template&id=88cd00a4"
import script from "./JsonNestedBlock.vue?vue&type=script&lang=js"
export * from "./JsonNestedBlock.vue?vue&type=script&lang=js"
import style0 from "./JsonNestedBlock.vue?vue&type=style&index=0&id=88cd00a4&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88cd00a4')) {
      api.createRecord('88cd00a4', component.options)
    } else {
      api.reload('88cd00a4', component.options)
    }
    module.hot.accept("./JsonNestedBlock.vue?vue&type=template&id=88cd00a4", function () {
      api.rerender('88cd00a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/JsonNestedTable/JsonNestedBlock.vue"
export default component.exports